const getPwaSettings = () => (drupalSettings && drupalSettings.pwa_settings) || null;

const getPathPrefix = () =>
  (drupalSettings && drupalSettings.path && drupalSettings.path.pathPrefix) || '';

const getUserId = () => (drupalSettings && drupalSettings.user && drupalSettings.user.uid) || '0';
const elearning_role = drupalSettings.user.elearning_role;
const allow_lms = (drupalSettings && drupalSettings.user && drupalSettings.user.elearning_role) || false;
export { getPwaSettings, getPathPrefix, getUserId, allow_lms };
